import styled from 'styled-components';
import {alignCenter, dFlexColumn, dFlexColumnCenter} from '../../../../../globalVariables/GlobalFlex';

export const successPanel = styled.div`
    ${dFlexColumnCenter};
    gap: var(--space-xl);
    width: 100%;
    padding: var(--space-lg) var(--space-lg) var(--space-xl);
    border-radius: var(--space-md);
    border: 2px solid var(--color-state-success-bg);
    background: var(--primitive-green-50);
    box-sizing: border-box;
`;

export const successTitle = styled.p`
    color: var(--color-text-default);
    text-align: start;
    font-size: var(--font-size-h3);
    font-weight: var(--font-weight-bold);
    line-height: 130%;
`;

export const successDetails = styled.div`
    ${dFlexColumn};
    ${alignCenter};
    gap: 0;
    width: 100%;
    text-align: center;
    color: var(--color-text-default);
    font-size: var(--font-size-button-primary);
    line-height: var(--line-height-body);
`;

export const successNameLine = styled.p`
    margin: 0;
    width: 100%;
    text-align: center;
`;

export const successDetailLine = styled.p`
    margin: 0;
    width: 100%;
    text-align: center;
    white-space: pre-wrap;
`;

export const successNotifyLine = styled.p`
    margin: var(--space-lg) 0 0;
    width: 100%;
    text-align: center;
`;
